import { MainNavigationStyles, MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import GridItem from "@insite/mobius/GridItem";
import React from "react";
import { DealsSectionStyles } from "./DealsSectionComponent";
import { SolutionSectionStyles } from "./SolutionAndServicesSectionComponent";
import { ShopSectionStyles } from "./ShopSectionComponent";
import { convertPromoHtmlToObjectValues } from "@NA/Utils/Utility";
import { useHistory } from "@NA/Hooks/useHistory";
import Link from "@insite/mobius/Link";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Typography } from "@insite/mobius/index";
import Img from "@insite/mobius/Img";

interface OwnProps {
    link: MappedLink;
    styles: DealsSectionStyles | SolutionSectionStyles  | ShopSectionStyles;
    onHandleClose: Function
}

const PromotionalContentCardDesign: React.FC<OwnProps> = ({ link, styles, onHandleClose}): any => {
    const tempDiv = document.createElement("div");
    const history = useHistory(); 

    tempDiv.innerHTML = link?.properties?.promotionalContent;
    const promos = convertPromoHtmlToObjectValues(link?.properties?.promotionalContent);

    const promoBannerLink = (url: any) => {
        sessionStorage.setItem("item_list_name", "menu_promo_content");
        history.push(url);
        onHandleClose();
    };


    return (
        <>
            <GridItem>
                {promos.map((promo, index) => (
                    <StyledWrapper key={index}>
                        <Link href={promo.link}  onClick={() => promoBannerLink(promo.link)}>
                            <Img src={promo.imgSrc} altText={promo.imgAlt}/>
                        </Link>
                        <StyledWrapper>
                            {promo.secondLinkText && (
                                <Link href={promo.link} {...styles.PromoImageDetailInfo} onClick={() => promoBannerLink(promo.link)}>
                                    {promo.secondLinkText}
                                </Link>
                            )}
                        </StyledWrapper>
                        <Typography as="p">{promo.description}</Typography>
                        <Link  href={promo.link} {...styles.PromoImageDetailInfo} onClick={() => promoBannerLink(promo.link)}>
                            {promo.ctaText}
                        </Link>
                    </StyledWrapper>
                ))}
            </GridItem>
        </>
    );
};
export default PromotionalContentCardDesign;

